import { css, Interpolation, Theme } from '@emotion/react';
import { theme } from '@frontend/theme';
import { ContactDetailsSection } from './contact-details-section';

type ContactDetailsProps = {
  children: React.ReactNode;
  styles?: Interpolation<Theme>;
};

export const Details = ({ children, styles }: ContactDetailsProps) => {
  return (
    <article
      css={[
        css`
          background-color: ${theme.colors.white};
          margin-bottom: ${theme.spacing(3)};
          box-shadow: ${theme.shadows.light};
          border-radius: ${theme.borderRadius.medium};
        `,
        styles,
      ]}
    >
      {children}
    </article>
  );
};

const ContactDetailsNamespace = Object.assign(Details, {
  Section: ContactDetailsSection,
});

export { ContactDetailsNamespace as ContactDetails };
